const FAQs = [
    {
        id: 1,
        title: "What types of vehicles do you service?",
        par: "We service all types of vehicles, including cars, trucks, and SUVs.",
    },
    {
        id: 2,
        title: "Do you use original spare parts?",
        par: "We use both OEM and high-quality aftermarket parts, depending on customer preference and budget.",
    },
    {
        id: 3,
        title: "How long does a regular service take?",
        par: "A standard maintenance service usually takes between 1-2 hours, depending on the vehicle.",
    },
    {
        id: 4,
        title: "Do you provide a warranty on repairs?",
        par: "Yes, we offer a warranty on both parts and labor. The terms depend on the type of repair.",
    },
    {
        id: 5,
        title: "Can I book an appointment online?",
        par: "Of course! You can schedule an appointment through our website or by calling us directly.",
    },
    {
        id: 6,
        title: "Do you offer emergency roadside assistance?",
        par: "Yes, we provide towing and emergency assistance in case of breakdowns.",
    },
    {
        id: 7,
        title: "How often should I change my oil?",
        par: "We recommend changing the oil every 5,000–7,000 miles, but it depends on your vehicle and driving style.",
    }
]


export default FAQs;